import { AppRouteProps } from '@bsm/component'
import React from 'react'
import { TeacherViewsRoutes } from 'views/TeacherViewsRoutes'

const TeachersContainer = React.lazy(() => import('./containers/TeachersContainer'))

export const TeachersRoutes: Array<AppRouteProps> = [
    {
        path: "teachers",
        title: 'BSM.Teacher.List.Title',
        element: <TeachersContainer />,
        children: [
            ...TeacherViewsRoutes
        ],
        roles: ["TEACHER"]
    }
]
